'use strict';

module.exports = function () {
    // back-to-top code enhanced, moved to backtotop.js
};
